import React, { useEffect, useState } from 'react';
import { JsonForms } from '@jsonforms/react';
import { JsonFormsCore, createAjv } from '@jsonforms/core';
import {
  materialCells,
  materialRenderers,
} from '@jsonforms/material-renderers';
import textInputControl, {
  textInputControlTester,
} from './renderers/TextInput';
import MaterialAutoCompleteControl, {
  materialEnumControlTester,
} from './renderers/MaterialEnumControl';

import ArrayLayout, {
  arrayLayoutTester,
} from './renderers/layouts/ArrayLayout';

const renderers = [
  ...materialRenderers,
  { tester: textInputControlTester, renderer: textInputControl },
  { tester: materialEnumControlTester, renderer: MaterialAutoCompleteControl },
  { tester: arrayLayoutTester, renderer: ArrayLayout },
];

interface FormProps {
  onChange?(state: Pick<JsonFormsCore, 'data' | 'errors'>): void;
  data: any;
  uischema: any;
  schema: any;
  ajv?: any;
  isReadonly?: boolean;
}

const defaultAjv = createAjv();

const validateRequired: any = (schema: any, data: any) => {
  let isValid = true;
  let msg = '';
  if (!data) {
    isValid = false;
    msg = '   ';
  }
  validateRequired.errors = [
    {
      keyword: 'validateRequired',
      message: msg,
      params: { keyword: 'validateRequired' },
    },
  ];
  return isValid;
};

defaultAjv.addKeyword({
  keyword: 'validateRequired',
  validate: validateRequired,
  errors: true,
  type: 'object',
  schemaType: 'boolean',
});
export const Form = ({
  onChange,
  data,
  uischema,
  schema,
  isReadonly,
  ajv,
}: FormProps) => {
  const [jsonformsData, setJsonformsData] = useState<any>(data);
  const [readonly, setReadOnly] = useState(isReadonly);
  const _ajv = ajv ? ajv : defaultAjv;

  useEffect(() => {
    setJsonformsData(data);
  }, [data]);

  useEffect(() => {
    setReadOnly(isReadonly);
  }, [isReadonly]);

  // On change handler
  const _changeHandler = (state: Pick<JsonFormsCore, 'data' | 'errors'>) => {
    if (state.data) {
      setJsonformsData(state.data);
    }
    if (onChange) {
      onChange(state);
    }
  };

  return (
    <JsonForms
      schema={schema}
      uischema={uischema}
      data={jsonformsData}
      renderers={renderers}
      cells={materialCells}
      onChange={_changeHandler}
      ajv={_ajv}
      readonly={readonly}
    />
  );
};
